export enum SaleStatusEnum {
  LEAFLET,
  OPPORTUNITY,
  PROPOSAL,
  HOT,
  EARNED_CLOSURE,
  MISSED_CLOSURE
}
